/**
* @author Ryan Gladstone, Vinny DeFrancesco (webpack configuration)
*/

import template from '../../notifications/delete-drawer/deleteNotification.html';

function NotificationCardController($scope, $state, $uibModal, analyticsService) {
  $scope.delete = (notification) => {
    $uibModal.open({
      template,
      controller: 'NotificationDeleteDrawerController',
      size: 'sm',
      resolve: {
        notification() {
          return notification;
        }
      }
    }).result.then(() => {
      analyticsService.trackEvent('Notification management', 'Deleted notification');
      _.remove($scope.notifications, notification);
    });
  };

  $scope.clone = (notification) => {
    analyticsService.trackEvent('Notification management', 'Cloned notification');
    $state.go('^.createnotification', { notificationId: notification.id, clone: true });
  };
}

const controllerConfig = [
  '$scope',
  '$state',
  '$uibModal',
  'analyticsService',
  NotificationCardController
];

export default controllerConfig;
